export default __webpack_public_path__ + "static/media/microcentrifuge_body.a39bbea8.svg";